import { __ } from '../i18n/vsme';

/** UX copy aligned with accounting-hub CompanyRow trial dossier gate. */
export const trialDossierMissionBlockedMessage = (): string =>
  __('Les missions dossier client nécessitent un abonnement actif pendant l’essai gratuit.');

/** Shown when a dossier mission start is blocked by subscription (wizard + API fallback). */
export const missionStartSubscriptionRequiredMessage = (): string =>
  __('Impossible de démarrer la mission. Vous devez posséder un abonnement');

export const canStartDossierMissionFromBootstrap = (
  bootstrap: { canStartDossierMission?: boolean } | null | undefined,
): boolean => bootstrap?.canStartDossierMission !== false;
